import admin from "./admin";
import seller from "./seller";

export const api = {
  ...admin,
  ...seller,
};
